<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      title="添加 订单"
      id-key="OrderId"
      :data="data"
      :form-rules="rules"
      :save-func="()=>{}"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12" v-if="data.OperId">
            <el-form-item label="单据编号" prop="OrderNo">
              <el-input v-model="data.OrderNo" placeholder="请输入单据编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.OperId">
            <el-form-item label="单据日期" prop="OrderDate">
              <el-date-picker
                type="date"
                v-model="data.OrderDate"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名称" prop="PersonId">
              <el-select v-model="data.PersonId" placeholder="请选择用户名称" clearable @change="onChangePerson">
                  <el-option v-for="item in personList" :key="item.PersonId" :value="item.PersonId"
                    :label="item.PersonName"></el-option>
                </el-select>
                <!-- <business   @restaurants="onChangeBusiness"
                  :state="data.BusiName"></business> -->
            </el-form-item>
          </el-col>         
          <el-col :span="24">
            <el-form-item label="配送方式">
              <el-radio-group v-model="data.IsPickSelf" v-if="!data.OperId">
                <el-radio :label="false">快递配送</el-radio>
                <el-radio :label="true">到店自提</el-radio>
              </el-radio-group>
              <span v-else>{{data.IsPickSelf?'到店自提':'快递配送'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!data.IsPickSelf">
          <el-col :span="24">
            <el-form-item label="配送地址" prop="AddressId">
              <template v-if="!data.OperId">
                <el-select v-model="data.AddressId" placeholder="请选择" style="width: 100%;">
                  <template v-for="(i,key) in Address">
                    <el-option :key="key" :label="i.ContactAddress" :value="i.RecordId"></el-option>
                  </template>
                </el-select>
              </template>
               <span v-else>{{data.ContactAddress}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="data.OperId">
          <el-col :span="8" v-if="data.Freight!=0">
            <el-form-item label="快递费用">
              <span>{{data.RealityExpressamount}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品总价">
              <span>{{data.GoodsAmount}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合计金额">
              <span style="color: #ff9a02;">{{data.Amount}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-divider>商品信息</el-divider> -->
        <!-- <el-table border :data="data.Goods" style="width: 100%">
          <el-table-column prop="GoodsName" label="商品名称" min-width="200px" />
          <el-table-column prop="Price" label="单价" min-width="110px">
            <template slot-scope="{row}">
              <el-input v-if="!data.OperId" @input="onInput(row)" v-model="row.Price"></el-input>
              <span v-else>{{row.Price}}</span>
            </template>
          </el-table-column>       
          <el-table-column prop="MainunitCount" label="销售数量" width="90px">
            <template slot-scope="{row}">
              <el-input
                v-if="!data.OperId"
                v-model="row.MainunitCount"
                type="number"
                @input="count(row)"
                @blur="onBlur(row,'MainunitCount')"
                @focus="onFocus(row,'MainunitCount')"
              ></el-input>
              <span v-else>{{row.MainunitCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="UnitName" label="销售单位" />
          <el-table-column prop="Amount" v-if="data.OperId" label="金额" min-width="120px" />
          <el-table-column fixed="right" align="center" width="80px" v-show="!data.OperId">
            <template slot="header">
              <i class="el-icon-circle-plus-outline add-icon" @click="addGoods"></i>
            </template>
            <template slot-scope="{$index}">
              <el-button icon="el-icon-delete" type="text" @click="delGoods($index)"></el-button>
            </template>
          </el-table-column>
        </el-table> -->
        <div class="box-header">
          <span>商品信息</span>
          <div>
            <el-button type="primary" @click="addGoods">添加</el-button>
            <el-button type="danger" @click="delGoods">删除</el-button>
          </div>
        </div>
        <el-table border :data="data.Goods" highlight-current-row @selection-change="onSelectGoods">
          <el-table-column type="selection" width="35" />
          <el-table-column prop="GoodsName" label="商品名称" min-width="260px">
            <template slot-scope="{row}">
              <goods-select v-model="row.GoodsName" :source="goods" @select="onSetGoods($event, row)" :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex" :listTotal="listTotal" @currentPage="currentPage($event, row)" @click.native="resetFun"
                @inputText="inputText($event, row)" :pageType="true" />
            </template>
          </el-table-column>
          <el-table-column prop="GoodsCode" label="商品编码" min-width="110px" />
          <el-table-column prop="AttributeName" label="规格型号" min-width="110px" />
          <el-table-column prop="TypeName" label="商品分类" min-width="110px" />
          <el-table-column prop="UnitName" label="单位" min-width="80px" />
          <el-table-column prop="MainunitCount" label="数量" min-width="100px">
            <template slot-scope="{ row }">
              <el-input v-model="row.MainunitCount" v-int @input="onInput(row,'MainunitCount')" placeholder="输入数量"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Price" label="单价" min-width="100px">
           
          </el-table-column>
          <el-table-column prop="SumAmount" label="金额" min-width="100px" />
        </el-table>
        <div style="margin-top: 15px;" v-if="noSubmit">
          <el-alert title="客户余额与可用额度不足，无法提交支付" type="warning" :closable="false"></el-alert>
        </div>
      </template>
      <template slot="footer">
        <el-button v-if="!data.OperId" type="primary" @click="settle">结 算</el-button>
        <template v-else>
          <el-button type="success" :disabled="noSubmit" @click="submit">提交支付</el-button>
          <el-button type="danger" @click="cancel">取消结算</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>      
      <goods-dialog ref="goodsDialog" in-dialog selectable multiple @select-multiple="setGoods" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import goodsDialog from "@/components/goods/info/listDialog";
//import business from "@/components/common/business/business";
import goodsSelect from "@/components/goods/goodsattribute/select";


export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    //business,
    goodsDialog,
    goodsSelect
  },
  data() {
    return {
      api: require("@/api/sale/order/order").default,
      business_api:  require("@/api/shop/business").default,
      person_api:  require("@/api/sale/person").default,
      address_api: require("@/api/sale/personaddress").default,      
      goodsattributeApi: require("@/api/goods/goodsattribute").default,
     // unit_api: require("@/api/goods/multiUnit").default,
      // goods_api: require("@/api/ba/wholesalerGoods").default,
      data: {
        OrderNo: "",
        OrderDate: this.$commonJs.getToday(),
        Cart: false,
        CouponCustomerId: 0,
        AddressId: null,
        IsPickSelf: false,
        PersonId: null,
        PersonName: "",
        Goods: [],

        OperId: null,
        IsSystem: true,
        Freight: 0,
        GoodsAmount: 0,
        Amount: 0,
        RemainAmount: 0, //大于0时，订单不能提交 (RemainAmount=订单金额-额度-余额)
        Balance: 0, //余额
        Limit: 0, //赊账额度
      },
      Address: [],
      personList: [],
      rules: {
        PersonId: [{ required: true, message: "请选择用户" }],
        AddressId: [{ required: true, message: "请选择配送地址" }],
        OrderDate: [{ required: true, message: "请选择单据时间" }],
      },
      selectGoods: [],
      DelGoods: [],
      goods: [], //商品列表
      initGoods: [],
      listTotal: 0,
      initTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
    };
  },
  
  beforeMount() {
    this.person_api.list({ }).then((res) => {
          this.loading(false);
          if (res.Code == 0) {
            this.personList = res.Data;
            this.personList.forEach(item=>{
              item.PersonId=item.RecordId;
            });
          }
        });
    this.goodsattributeApi.list({ Status: 1, pageIndex: 1, pageSize: 7 }).then((res) => {
      if (res.Code == 0) {
        this.initGoods = this.goods = res.Data;
        this.initTotal = this.listTotal = res.Count;
      }
    });
  },
  computed: {
    fullAddress() {
      var address = this.Address.find(
        (x) => x.AddressId == this.data.AddressId
      );
      if (address) return address.FullAddress;
      else return "";
    },
    noSubmit() {
      return this.data.RemainAmount > 0;
    },
   
  },
  methods: {
    onDetailsOpened(data) {
    
    },
    onChangePerson(val){
      console.log(val,"val");
      this.data.PersonId=val.RecordId;
      this.data.PersonName=val.PersonName;
      if(val){      
          this.Address=[]
          this.data.AddressId=null;
          this.address_api.list({PersonId:val.RecordId}).then((e)=>{
            if(e.Code==0)
            this.Address=e.Data
            console.log(this.Address,"this.Address");
            var item= this.Address.find((x)=>x.IsDefault==1);
            console.log(item,"item");
            if(item){
              this.data.AddressId=item.RecordId;
            }
          })
        
      }
      
    },
    onSelectGoods(selection) {
      this.selectGoods = selection;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.goods = this.initGoods;
      this.listTotal = this.initTotal;
    },
    currentPage(data, row) {
      this.pageParams.pageIndex = data.val;
      this.goodsattributeApi.list({ Status: 1, pageIndex: data.val, pageSize: 7, GoodsName: row.GoodsName }).then((res) => {
        if (res.Code == 0) {
          this.goods = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text, row) {
      row.GoodsName = text;
      this.goodsattributeApi.list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text }).then((res) => {
        if (res.Code == 0) {
          this.goods = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    addGoods() {
      if (!this.data.PersonId) {
        this.$message.warning("请先选择用户");
        return;
      }
      if (!this.data.IsPickSelf && !this.data.AddressId) {
        this.$message.warning("请选择配送地址");
        return;
      }
      var ids = this.data.Goods.map((x) => x.RecordId);
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getTree();
      //   that.getData({ Status: 1, NotIds: ids, PromotionType: 0 });
      // });
      this.data.Goods.push({
        Index: this.data.Goods.length,
        RecordId: 0,
        OrdermainId: this.data.RecordId,
        OrderId: 0, //序号
        GoodsId: null, //商品
        GoodsCode: "", //商品编码
        GoodsName: "", //商品名称
        TypeName: "", //商品分类
        UnitName: "", //单位
        AttributeId: null, //属性
        AttributeName: "", //属性名称
        MainunitCount: null, //数量
        Price: null, //单价
        SumAmount: null, //金额
        T: 0
      })
    },
     onSetGoods(e, row) {
      console.log("商品", JSON.parse(JSON.stringify(e)));
      console.log("明细", JSON.parse(JSON.stringify(row)));

      if (this.data.Goods.some(x => x.GoodsId == e.GoodsId && x.AttributeId == e.RecordId)) {
        this.$message.warning("已存在商品和商品属性相同的明细");
        return;
      }

      if (row.T !== 0) row.T = 1;

      row.GoodsId = e.GoodsId;
      row.GoodsCode = e.GoodsCode;
      row.GoodsName = e.GoodsName;
      row.TypeName = e.TypeName;
      row.UnitName = e.MainUnitName;
      row.AttributeId = e.RecordId;
      row.AttributeName = e.AttributeName;
      row.Price = e.PlatformPrice;
    },
    onInput(row, type) {
      if (row.T !== 0) row.T = 1;

      if (row.Price) {
        var PriceStr = row.Price.toString();
        row.Price = PriceStr.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, "$1");
      }

      var mainunitCountCount = parseFloat(row.MainunitCount);
     
      var price = parseFloat(row.Price);
      if (!Number.isNaN(mainunitCountCount) && !Number.isNaN(price)) {
        row.SumAmount = parseFloat((mainunitCountCount * price).toFixed(2));
      } else {
        row.SumAmount = null;
      }
      console.log("SumAmount",row.SumAmount);
      console.log(this.data.Goods);
    },
    setGoods(data) {
      console.log("setGoods", data);
      var ids=[];
      data.forEach((x)=>{
        var goods=this.data.Goods.find(w=>w.GoodsId==x.RecordId);
        if(goods){
          ids.push(x.RecordId)
          return;
        }
      })
      if(ids.length>0){
        this.$message.error("存在相同的商品");
        return false;
      }

      data.forEach((x) => {   
        this.data.Goods.push({
          ...x,
          RecordId:0,
          GoodsId:x.RecordId,
          Price: x.OriginalPrice,
          MainunitCount: 1,
          AuxiunitCount: 1,
          UnitId: x.MainUnitId,
          UnitName: x.MainUnitName,
          UnitId1: x.SaleUnitId,
          UnitName1: x.SaleUnitName,
        });
      });
    },
    delGoods(index) {
      this.data.Goods.splice(index, 1);
    },
    settle() {
      if (!this.data.BusiId) {
        this.$message.warning("商家不能为空");
        return;
      }
      if (!this.data.IsPickSelf && !this.data.AddressId) {
        this.$message.warning("配送地址不能为空");
        return;
      }
      if (this.data.Goods.length == 0) {
        this.$message.warning("请选择商品");
        return;
      }

      var data = { ...this.data, Goods: [] };
      if (data.AddressId == null) data.AddressId = 0;
      data.Goods = this.data.Goods.map((x) => {
        return {
          GoodsId: x.GoodsId,
          IsPickSelf: this.data.IsPickSelf,
          Price: x.Price,
          Quantity1: x.MainunitCount,
          AuxiunitCount: x.AuxiunitCount,
          UnitId: x.UnitId,
          UnitName: x.UnitName,
          UnitId1: x.UnitId1,
          UnitName1: x.UnitName1,
          SumAmount:x.MainunitCount*x.Price,
          AttributeId:x.AttributeId,
          AttributeValue:x.AttributeValue
        };
      });
      this.api.settle(data).then((res) => {
        if (res.Code == 0) {
          this.data.Goods = res.Data.Goods;
          console.log(this.data.Goods,"res.Data.Goods");
          this.data.OperId = res.Data.OperId;
          // this.data.IsPickSelf = res.Data.PickSelf;
          this.data.Freight = res.Data.Freight;
          this.data.GoodsAmount = res.Data.GoodsAmount;
          this.data.Amount = res.Data.Amount;
          this.data.RemainAmount = res.Data.RemainAmount;
          this.data.Balance = res.Data.Balance; //余额
          this.data.Limit = res.Data.Limit; //赊账额度
        } else if (res.Code == 2) {
          this.$message.error("不允许下单");
        }else if (res.Code == 3) {
          this.$message.error("没有地址");
        }  else if (res.Code == 4) {
          this.$message.error("有未付款订单");
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    submit() {
      var config = {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      };
      this.$confirm("确认提交吗？", "提示", config)
        .then(() => {
          this.api
            .submitV2({
              OperId: this.data.OperId,
              OrderNo: this.data.OrderNo,
              OrderDate: this.data.OrderDate,
            })
            .then((res) => {
              if (res.Code == 0) {
                this.$message.success(res.Msg);
                this.close(true);
                this.$emit("close-saved");
              } else {
                this.$message.error(res.Msg);
              }
            });
        })
        .catch(() => {});
    },
    unitChange(row, name) {
      console.log(row);
      row.Units.forEach((e) => {
        if (e.UnitId == row["UnitId" + name]) {
          row["Rate" + name] = e.Rate;
        }
      });
      this.count(row);
    },
    cancel() {
      this.data.OperId = null;
      this.data.IsPickSelf = false;
      this.data.Freight = 0;
      this.data.GoodsAmount = 0;
      this.data.Amount = 0;
      this.data.RemainAmount = 0;
      this.data.Balance = 0; //余额
      this.data.Limit = 0; //赊账额度
    },
    // onInput(row) {
    //   row.Quantity = this.$commonJs.obj.toInt(row.Quantity);
    // },
    onClosed() {
      this.data.Goods = [];
      this.Address = [];
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    count(row) {
      // let price = row.Price ? Number(row.Price) : 0;
      // let dis = row.Discount > 0 ? Number(row.Discount) : 100;
      // let dis = 100;
      let qua = row.Quantity1 ? Number(row.Quantity1) : 0;
      // let rate = row.TaxRate ? Number(row.TaxRate) : 0;
      // let rate = 0;
      // let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0;
      // if (row.T !== 0) row.T = 1;
      // row.Price = dis
      //   ? (row.Price * (dis / 100) * (1 + rate / 100)).toFixed(2)
      //   : (row.Price * (1 + rate / 100)).toFixed(2);
      // console.log("price", row.Price);
      // row.Amount = ((row.Price * qua * 100) / 100).toFixed(2);
      // row.NoTaxAmount = (row.Offer * (dis / 100) * row.Quantity1).toFixed(2);
      // row.TaxAmount =
      //   (
      //     (qua *
      //       (((dis ? row.Offer * (dis / 100) : row.Offer) * rate) / 100) *
      //       100) /
      //     100
      //   ).toFixed(2) || 0;
      // row.GrossProfit = (row.Amount - qua * ref).toFixed(2);
      row.Quantity = (1 / row.Rate) * qua;
      // if (row.UnitId2 == row.UnitId) {
      //   row.Quantity2 = row.Quantity;
      // } else {
      //   console.log(row.Rate2, row.Quantity);
      //   if (!row.Rate2) {
      //     row.Quantity2 = 0;
      //   } else {
      //     row.Quantity2 = row.Rate2 * row.Quantity;
      //   }
      // }
      // this.subTable();
    },
  },
};
</script>